
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CheckListGrid extends Serenity.EntityGrid<CheckListRow, any> {
        protected getColumnsKey() { return 'OMS.CheckList'; }
        protected getDialogType() { return CheckListDialog; }
        protected getIdProperty() { return CheckListRow.idProperty; }
        protected getInsertPermission() { return CheckListRow.insertPermission; }
        protected getLocalTextPrefix() { return CheckListRow.localTextPrefix; }
        protected getService() { return CheckListService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}